import { call, fork, put, take } from "redux-saga/effects";

import { Company } from "../../domain/model/company";
import { Project } from "../../domain/model/project";

import { ICompanyRepository } from "../../domain/repository/company_repository";
import { IProjectRepository } from "../../domain/repository/project_repository";

import { createApiClient, IApiClient } from "../../infra/api/client";
import { createCompanyAPI } from "../../infra/api/service/company_api";
import { createProjectAPI } from "../../infra/api/service/project_api";
import {
  ClientProjectListActionType,
  createClientProjectListActionCreator,
  IClientProjectListActionCreator,
  IRequestCopyProjectAction,
  IRequestGetAllByClientProjectListAction,
} from "../action/client_projects_action";

const apiClient: IApiClient = createApiClient();
const projectRepository: IProjectRepository = createProjectAPI(apiClient);
const companyRepository: ICompanyRepository = createCompanyAPI(apiClient);

import { AppNotificationType } from "src/domain/model/app_notification_message";
import {
  createAppNotificationMessageActionCreator,
  IAppNotificationMessageActionCreator,
} from "src/presentation/action/app_notification_message_action";
import { AddAppNotificationRequest } from "src/presentation/request/app_notification_message_request";
import {
  CopyProjectResponse,
  GetAllProjectListByClientResponse,
} from "../response/project_response";
import { handleErrorForHandler } from "./handleErrorForHandler";

const actionCreator: IClientProjectListActionCreator =
  createClientProjectListActionCreator();
const actionCreatorForNotification: IAppNotificationMessageActionCreator =
  createAppNotificationMessageActionCreator();

function* handleGetAllByClientProjectListInClientProjectList() {
  while (true) {
    try {
      const action: IRequestGetAllByClientProjectListAction = yield take(
        ClientProjectListActionType.REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST
      );
      const projectList: Project[] = yield call(
        getAllByClientProjectList,
        action.item.pager.page,
        action.item.pager.offset
      );
      const companyIdList: string[] = yield call(
        createCompanyIdList,
        projectList
      );
      const companyList: Company[] = yield call(getCompanyList, companyIdList);
      const projectCount: number = yield call(getCountByClient);
      const res: GetAllProjectListByClientResponse =
        new GetAllProjectListByClientResponse();
      res.projects = projectList;
      res.companies = companyList;
      res.projectCount = projectCount;
      yield put(
        actionCreator.callbackGetAllByClientProjectListAction(true, res)
      );
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(actionCreator.callbackGetAllByClientProjectListAction(false));
    }
  }
}

function* handleCopyProject() {
  while (true) {
    try {
      const action: IRequestCopyProjectAction = yield take(
        ClientProjectListActionType.REQUEST_COPY_PROJECT
      );
      const project: Project = yield call(copy, action.item.projectId);
      const res: CopyProjectResponse = new CopyProjectResponse();
      res.project = project;
      yield put(actionCreator.callbackCopyProjectAction(true, res));

      const notificationReq: AddAppNotificationRequest =
        new AddAppNotificationRequest();
      notificationReq.type = AppNotificationType.INFO;
      notificationReq.message = "複製しました";
      yield put(actionCreatorForNotification.requestAddAction(notificationReq));
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(actionCreator.callbackCopyProjectAction(false));
    }
  }
}

const createCompanyIdList = (projectList: Project[]): string[] => {
  return projectList.map((item: Project) => {
    return item.companyID;
  });
};

const getAllByClientProjectList = (
  page: number,
  offset: number
): Promise<Project[]> => {
  return projectRepository.getAllByClient(page, offset);
};

const getCompanyList = (companyIdList: string[]): Promise<Company[]> => {
  return companyRepository.getAllByIDs(companyIdList);
};

const getCountByClient = (): Promise<number | Long> => {
  return projectRepository.getCountByClient();
};

const copy = (projectId: string): Promise<Project> => {
  return projectRepository.copy(projectId);
};

export {
  handleCopyProject,
  handleGetAllByClientProjectListInClientProjectList,
};



// WEBPACK FOOTER //
// ./src/presentation/handler/client_projects_handler.ts